import { observer } from "mobx-react-lite";
import { FC, useCallback } from "react";
import { useAppStore } from "@/store";
import { windowModule } from "@/modules/window";
import { oauthModule } from "@/modules/oauth";
import { OAuthCard } from "@/pages/oauth-consent/oauth-card";

interface OAuthConsentPageFormProps {
  redirectUri: string;
  clientId: string;
  state: string;
  scopeStr: string;
}

export const OAuthConsentPageForm: FC<OAuthConsentPageFormProps> = observer(
  ({ redirectUri, clientId, state, scopeStr }) => {
    const { store } = useAppStore();

    /** TODO: Make this server-provided. */
    const appName = `Zapier`;

    const { profileDisplayName, profileEmailAddress, profilePhotoUrl } = store.account.myAccount;

    const approve = useCallback(async () => {
      const result = await oauthModule.approveOAuthConsent({
        clientId,
        redirectUri,
        scope: scopeStr,
        state,
      });

      if (result?.redirect_url) {
        await windowModule.navigateToExternal({ url: new URL(result.redirect_url) });
      }
    }, [clientId, redirectUri, scopeStr, state]);

    const deny = useCallback(async () => {
      const result = await oauthModule.denyOAuthConsent({
        clientId,
        redirectUri,
        scope: scopeStr,
        state,
      });

      if (result?.redirect_url) {
        await windowModule.navigateToExternal({ url: new URL(result.redirect_url) });
      }
    }, [clientId, redirectUri, scopeStr, state]);

    return (
      <OAuthCard
        appName={appName}
        accountInfo={{
          profileDisplayName,
          profileEmailAddress,
          profilePhotoUrl,
        }}
        scopeStr={scopeStr}
        handleApprove={approve}
        handleDeny={deny}
      />
    );
  }
);
